export const PROJECTHOURSLIST_SEARCH = 'PROJECTHOURSLIST_SEARCH';
export const PROJECTHOURSLIST_PAGE = 'PROJECTHOURSLIST_PAGE';
export const PROJECTHOURSLIST_PERIOD = 'PROJECTHOURSLIST_PERIOD';
export const PROJECTHOURSLIST_YEAR = 'PROJECTHOURSLIST_YEAR';